import React from 'react';
import { UrlCollectionSarang } from "../common/url-collection-sarang";
import BreadcrumbConfig from "../breadcrumb";
import LayoutSarangView from "../components/layout-sarang/layout-sarang.view";

// Page imports
import DesktopHome from "../pages/dashboard-home/desktop-home.jsx";
import ExamDashboard from "../pages/examination-dashboard/exam-dashboard.jsx";
import HerdsmanList from "../pages/list-herdsman/list-herdsman.jsx";
import HerdsmanWMList from "../pages/list-herdsman/list-herdsman-wm.jsx";
import HerdsmanListPointThreeMonth from "../pages/list-herdsman/list-herdsman-point-three-month.jsx";
import CustomerList from "../pages/list-customer/list-customer.jsx";
import CustomerNeedHelpList from "../pages/list-customer/list-customer-need-help.jsx";
import CuisineOrderList from "../pages/list-cuisine-order/list-cuisine-order";
import TransportList from "../pages/list-transport-order/list-transport-order";
import SendCuisineToShipper from "../pages/list-transport-order/send-cuisine-to-shipper.jsx";
import DepartmentList from "../pages/list-department/list-department";
import BranchList from "../pages/list-branch/list-branch.jsx";
import ZionAreaList from "../pages/list-zion-area/list-zion-area.jsx";
import FeedbackList from "../pages/feedback/list-feedback.jsx";
import SwatTrundoInput from "../pages/swat-trundo/swat-trundo-input.jsx";
import SwatTrundoSumaryHerdsmanReport from "../pages/swat-trundo/report/sumary-herdsman-report.jsx";
import SwatTrundoSumaryHerdsmanWMTeamReport from "../pages/swat-trundo/report/sumary-herdsman-wmteam-report.jsx";
import SwatTrundoSumaryDepartmentReport from "../pages/swat-trundo/report/sumary-department-report.jsx";
import SwatTrundoSumaryZionReport from "../pages/swat-trundo/report/sumary-zion-report.jsx";
import SwatTrundoSumaryWMTeamReport from "../pages/swat-trundo/report/sumary-wmteam-report.jsx";
import SwatTrundoSumaryByDateReport from "../pages/swat-trundo/report/sumary-by-date-report.jsx";
import MemberCountInput from "../pages/member-count/member-count-input.jsx";
import HerdsmanAcademyConfirm from "../pages/herdsman-academy/herdsman-academy-confirm.jsx";
import MediaList from "../pages/list-media/list-media.jsx";
import CalendarContact from "../pages/calendar-contact/index.js";
import CalendarNeedHelp from "../pages/calendar-contact/list-task/list-task-need-help.jsx";
import DashboardCuisineOrder from "../pages/list-cuisine-order/dashboard-cuisine-order.jsx";
import BlankPage from "../pages/dashboard-home/blankpage.jsx";
import RptCustomerStepDepartment from "../pages/sumary-report/report-customer-step-department.jsx";
import ExamHerdsmanReport from "../pages/sumary-report/examination-herdsman-report.jsx";
import ExamDepartmentReport from "../pages/sumary-report/examination-department-report.jsx";
import ExamDeliveryReport from "../pages/sumary-report/examination-delivery-report.jsx";
import ExamSumaryDepartmentReport from "../pages/sumary-report/examination-sumary-report.jsx";
import MyReportAcademy from "../pages/report-academy/my-report-academy.jsx";
import ExamAcademyDashboard from "../pages/report-academy/exam-academy-dashboard.jsx";
import ReportSumaryAcademy from "../pages/report-academy/report-sumaries-academy.jsx";
import SwatReportList from "../pages/report-activity-swat/list-swat-report";
import ProfilePage from "../pages/profile/profile.jsx";
import RoleManagement from "../modules/role-management/role-management";
import UserManagement from "../modules/user-management/user-management.view";

const wrapLayout = (title, breadcrumbKey, Component) => () => (
    <LayoutSarangView
        title={title}
        breadcrumbList={BreadcrumbConfig[breadcrumbKey].breadcrumbList}
        breadcrumbActive={BreadcrumbConfig[breadcrumbKey].breadcrumbActive}
    >
        <Component />
    </LayoutSarangView>
);

export const sarangRoutes = [
    {
        path: UrlCollectionSarang.DesktopHome,
        component: DesktopHome,
        layout: wrapLayout("", "DashboardHome", DesktopHome),
        exact: true
    },
    {
        path: UrlCollectionSarang.ExamDashboard,
        component: ExamDashboard,
        layout: wrapLayout("Vinh danh", "DashboardHome", ExamDashboard),
        exact: true
    },
    {
        path: UrlCollectionSarang.HerdsmanList,
        component: HerdsmanList,
        layout: wrapLayout("Danh sách T.Đồ", "HerdsmanList", HerdsmanList)
    },
    {
        path: UrlCollectionSarang.HerdsmanWMList,
        component: HerdsmanWMList,
        layout: wrapLayout("Danh sách T.Đồ WM", "HerdsmanWMList", HerdsmanWMList)
    },
    {
        path: UrlCollectionSarang.HerdsmanListPointThreeMonth,
        component: HerdsmanListPointThreeMonth,
        layout: wrapLayout("Điểm tích lũy swat", "HerdsmanListPointThreeMonth", HerdsmanListPointThreeMonth)
    },
    {
        path: UrlCollectionSarang.CustomerList,
        component: CustomerList,
        layout: wrapLayout("Danh sách ta-lâng", "CustomerList", CustomerList)
    },
    {
        path: UrlCollectionSarang.CustomerNeedHelpList,
        component: CustomerNeedHelpList,
        layout: wrapLayout("Ta-lâng cần bàn giao", "CustomerNeedHelpList", CustomerNeedHelpList)
    },
    {
        path: UrlCollectionSarang.CuisineOrder,
        component: CuisineOrderList,
        layout: wrapLayout("Danh sách đăng ký suất ăn", "CuisineOrder", CuisineOrderList)
    },
    {
        path: UrlCollectionSarang.ReportActivityShipping,
        component: TransportList,
        layout: wrapLayout("Theo dõi Đơn hàng", "ReportActivityShipping", TransportList)
    },
    {
        path: UrlCollectionSarang.SendCuisineToShipper,
        component: SendCuisineToShipper,
        layout: wrapLayout("Giao shipper", "SendCuisineToShipper", SendCuisineToShipper)
    },
    {
        path: UrlCollectionSarang.Department,
        component: DepartmentList,
        layout: wrapLayout("Biệt đội", "Department", DepartmentList)
    },
    {
        path: UrlCollectionSarang.Branch,
        component: BranchList,
        layout: wrapLayout("Chi hội", "Branch", BranchList)
    },
    {
        path: UrlCollectionSarang.ZionArea,
        component: ZionAreaList,
        layout: wrapLayout("Biệt đội", "ZionArea", ZionAreaList)
    },
    {
        path: UrlCollectionSarang.Feedback,
        component: FeedbackList,
        layout: wrapLayout("Sự cố", "Feedback", FeedbackList)
    },
    {
        path: UrlCollectionSarang.SwatTrundoInput,
        component: SwatTrundoInput,
        layout: wrapLayout("Báo cáo hoạt động trundo", "SwatTrundoInput", SwatTrundoInput)
    },
    {
        path: UrlCollectionSarang.SwatTrundoSumaryHerdsmanReport,
        component: SwatTrundoSumaryHerdsmanReport,
        layout: wrapLayout("Báo cáo hoạt động trundo theo T/Đồ", "SwatTrundoSumaryHerdsmanReport", SwatTrundoSumaryHerdsmanReport)
    },
    {
        path: UrlCollectionSarang.SwatTrundoSumaryHerdsmanWMTeamReport,
        component: SwatTrundoSumaryHerdsmanWMTeamReport,
        layout: wrapLayout("Tổng hợp hoạt động trundo theo T/Đồ WM", "SwatTrundoSumaryHerdsmanWMTeamReport", SwatTrundoSumaryHerdsmanWMTeamReport)
    },
    {
        path: UrlCollectionSarang.SwatTrundoSumaryDepartmentReport,
        component: SwatTrundoSumaryDepartmentReport,
        layout: wrapLayout("Tổng hợp hoạt động trundo theo địa vực", "SwatTrundoSumaryDepartmentReport", SwatTrundoSumaryDepartmentReport)
    },
    {
        path: UrlCollectionSarang.SwatTrundoSumaryZionReport,
        component: SwatTrundoSumaryZionReport,
        layout: wrapLayout("Tổng hợp hoạt động trundo theo khu vực", "SwatTrundoSumaryZionReport", SwatTrundoSumaryZionReport)
    },
    {
        path: UrlCollectionSarang.SwatTrundoSumaryWMTeamReport,
        component: SwatTrundoSumaryWMTeamReport,
        layout: wrapLayout("Báo cáo hoạt động trundo theo WM", "SwatTrundoSumaryWMTeamReport", SwatTrundoSumaryWMTeamReport)
    },
    {
        path: UrlCollectionSarang.SwatTrundoSumaryByDateReport,
        component: SwatTrundoSumaryByDateReport,
        layout: wrapLayout("Chi tiết hoạt động trundo theo T/Đồ", "SwatTrundoSumaryByDateReport", SwatTrundoSumaryByDateReport)
    },
    {
        path: UrlCollectionSarang.MemberCountInput,
        component: MemberCountInput,
        layout: wrapLayout("Đăng ký số lượng phát biểu", "MemberCountInput", MemberCountInput)
    },
    {
        path: UrlCollectionSarang.HerdsmanAcademyConfirm,
        component: HerdsmanAcademyConfirm,
        layout: wrapLayout("Xác nhận phát biểu GĐ2", "HerdsmanAcademyConfirm", HerdsmanAcademyConfirm)
    },
    {
        path: UrlCollectionSarang.Helping,
        component: MediaList,
        layout: wrapLayout("Hướng dẫn", "Helping", MediaList)
    },
    {
        path: UrlCollectionSarang.Organization,
        component: CalendarContact,
        layout: wrapLayout("Hội thánh/chi hội", "Organization", CalendarContact)
    },
    {
        path: UrlCollectionSarang.DashboardCooking,
        component: DashboardCuisineOrder,
        layout: wrapLayout("Biểu đồ tổng hợp Ẩm thực", "DashboardCooking", DashboardCuisineOrder)
    },
    {
        path: UrlCollectionSarang.DashboardShipping,
        component: BlankPage,
        layout: wrapLayout("Biểu đồ tổng hợp Đơn hàng", "DashboardShipping", BlankPage)
    },
    {
        path: UrlCollectionSarang.CalendarContact,
        component: CalendarContact,
        layout: wrapLayout("Lịch hẹn chia sẻ", "CalendarContact", CalendarContact)
    },
    {
        path: UrlCollectionSarang.CalendarNeedHelp,
        component: CalendarNeedHelp,
        layout: wrapLayout("Ca chia sẻ cần trợ giúp", "CalendarNeedHelp", CalendarNeedHelp)
    },
    {
        path: UrlCollectionSarang.RptCustomerStepDepartment,
        component: RptCustomerStepDepartment,
        layout: wrapLayout("Tổng hợp ta lâng theo bước", "RptCustomerStepDepartment", RptCustomerStepDepartment)
    },
    {
        path: UrlCollectionSarang.ExamHerdsmanReport,
        component: ExamHerdsmanReport,
        layout: wrapLayout("Báo cáo xếp hạng trudo SWAT", "ExamHerdsmanReport", ExamHerdsmanReport)
    },
    {
        path: UrlCollectionSarang.ExamDepartmentReport,
        component: ExamDepartmentReport,
        layout: wrapLayout("Báo cáo xếp hạng trudo SWAT", "ExamHerdsmanReport", ExamDepartmentReport)
    },
    {
        path: UrlCollectionSarang.ExamDeliveryReport,
        component: ExamDeliveryReport,
        layout: wrapLayout("Báo cáo xếp hạng trudo SWAT", "ExamDeliveryReport", ExamDeliveryReport)
    },
    {
        path: UrlCollectionSarang.ExamSumaryDepartmentReport,
        component: ExamSumaryDepartmentReport,
        layout: wrapLayout("Tổng hợp hoạt động trundo theo biệt đội", "ExamDeliveryReport", ExamSumaryDepartmentReport)
    },
    {
        path: UrlCollectionSarang.MyReportAcademy,
        component: MyReportAcademy,
        layout: wrapLayout("Phát biểu lễ hội lời", "MyReportAcademy", MyReportAcademy)
    },
    {
        path: UrlCollectionSarang.ExamAcademyDashboard,
        component: ExamAcademyDashboard,
        layout: wrapLayout("Vinh danh lễ hội lời", "ExamAcademyDashboard", ExamAcademyDashboard)
    },
    {
        path: UrlCollectionSarang.ReportSumaryAcademy,
        component: ReportSumaryAcademy,
        layout: wrapLayout("Thống kê lễ hội lời", "ExamAcademyDashboard", ReportSumaryAcademy)
    },
    {
        path: UrlCollectionSarang.SwatReportList,
        component: SwatReportList,
        layout: wrapLayout("Báo cáo hoạt động Swat", "SwatReportList", SwatReportList)
    },
    {
        path: UrlCollectionSarang.Profile,
        component: ProfilePage,
        layout: wrapLayout("Tài khoản", "Profile", ProfilePage)
    },
    {
        path: UrlCollectionSarang.RoleManagement,
        component: RoleManagement,
        layout: wrapLayout("Nhóm quyền", "RoleManagement", RoleManagement)
    },
    {
        path: UrlCollectionSarang.UserManagement,
        component: UserManagement,
        layout: wrapLayout("Người sử dụng", "UserManagement", UserManagement)
    }
];
